import { render, staticRenderFns } from "./SourceTypeNavigation.vue?vue&type=template&id=1289e847&scoped=true&"
import script from "./SourceTypeNavigation.vue?vue&type=script&lang=js&"
export * from "./SourceTypeNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SourceTypeNavigation.vue?vue&type=style&index=0&id=1289e847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289e847",
  null
  
)

export default component.exports